export const REGIONI = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna",
  "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche",
  "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia",
  "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
];

export const SETTORI = [
  { v: "Freelance/Consulenza", l: "Freelance / Consulenza" },
  { v: "Commercio", l: "Commercio / Negozio" },
  { v: "Artigianato", l: "Artigianato" },
  { v: "Ristorazione", l: "Ristorazione" },
  { v: "Edilizia", l: "Edilizia" },
  { v: "Agricoltura", l: "Agricoltura" },
  { v: "Tech", l: "Tech / Digitale" },
  { v: "Servizi alla persona", l: "Servizi alla persona" },
  { v: "Manifatturiero", l: "Manifatturiero" },
  { v: "Altro", l: "Altro" },
];

export const TIPI_PIVA = [
  { v: "nessuna", l: "Dipendente / Pensionato (nessuna P.IVA)" },
  { v: "forfettario", l: "Regime Forfettario" },
  { v: "ordinario", l: "Regime Ordinario" },
];

// Solo per dipendenti/pensionati — inquadramento contrattuale principale
export const TIPI_LAVORO = [
  { v: "impiegato", l: "Impiegato" },
  { v: "operaio", l: "Operaio" },
  { v: "quadro", l: "Quadro" },
  { v: "dirigente", l: "Dirigente" },
  { v: "apprendista", l: "Apprendista" },
  { v: "insegnante", l: "Insegnante / Docente" },
  { v: "pubblico", l: "Dipendente pubblico / statale" },
  { v: "pensionato", l: "Pensionato" },
  { v: "altro", l: "Altro / Non specifico" },
];

// Fasce di reddito annuo lordo (RAL) per dipendenti/pensionati
export const FASCE_RAL = [
  { v: "0_20k", l: "Fino a €20.000" },
  { v: "20_30k", l: "€20.000 – €30.000" },
  { v: "30_50k", l: "€30.000 – €50.000" },
  { v: "50_75k", l: "€50.000 – €75.000" },
  { v: "75k_plus", l: "Oltre €75.000" },
  { v: "np", l: "Preferisco non dirlo" },
];

export const DIMENSIONI = [
  { v: "solo", l: "Solo io (freelance)" },
  { v: "micro", l: "Micro (< 10 persone)" },
  { v: "piccola", l: "Piccola (10-50 persone)" },
  { v: "media", l: "Media (50-250 persone)" },
];

// Casse previdenziali principali (albi/professioni + speciali)
export const CASSE = [
  { v: "", l: "Nessuna" },
  { v: "INPS Gestione Separata", l: "INPS Gestione Separata (freelance senza albo)" },
  { v: "Inarcassa", l: "Inarcassa (ingegneri e architetti)" },
  { v: "Cassa Forense", l: "Cassa Forense (avvocati)" },
  { v: "Cassa Nazionale del Notariato", l: "Cassa del Notariato" },
  { v: "CNPADC", l: "CNPADC (dottori commercialisti)" },
  { v: "Cassa Ragionieri", l: "CNPR (ragionieri)" },
  { v: "Cassa Geometri", l: "Cassa Geometri" },
  { v: "Cassa Periti Industriali", l: "EPPI (periti industriali)" },
  { v: "ENPAM", l: "ENPAM (medici e odontoiatri)" },
  { v: "ENPAP", l: "ENPAP (psicologi)" },
  { v: "ENPAB", l: "ENPAB (biologi)" },
  { v: "ENPAF", l: "ENPAF (farmacisti)" },
  { v: "ENPAV", l: "ENPAV (veterinari)" },
  { v: "ENPACL", l: "ENPACL (consulenti del lavoro)" },
  { v: "ENPAPI", l: "ENPAPI (infermieri professionali)" },
  { v: "Enasarco", l: "Enasarco (agenti di commercio)" },
  { v: "Cassa Edile", l: "Cassa Edile (edilizia)" },
  { v: "Altro", l: "Altro" },
];
